import React, { PropsWithChildren } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import clsx from 'clsx'

interface PopupProps {
    onClose(): void
    showClose?: boolean
    className?: string
}

const Popup = (props: PropsWithChildren<PopupProps>) => {
    const { onClose, children, showClose, className } = props
    return (
        <div className={clsx('popup-component', className)}>
            {showClose && <img onClick={onClose} className="close" src={ICONS.close} alt="close" />}
            {children}
        </div>
    )
}

export default Popup
